import React, { Component } from 'react';
import './MenuBar.css';


class MenuBar extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  cityClick(cityname) {    
    this.props.setCity(cityname);
  }

  render() {
    return (
      <div className="Menu">
        <div className="SensingCity">Sensing.City</div>
        <div className="Perth">
          <div className="PerthLabel" onClick={(e) => {this.cityClick(e.target)}}>Perth</div>
          
        </div>
        <div className="Melbourne">
          <div className="MelbourneLabel" onClick={(e) => {this.cityClick(e.target)}}>Melbourne</div>
          
        </div>
        <div className="HoChiMinh">
          <div className="HoChiMinhLabel" onClick={(e) => {this.cityClick(e.target)}}>HoChiMinh</div>
          
        </div>
        <div className="MenuSpace"></div>
        <div className="Login">Login</div>
        <div className="Logout" onClick={()=>{this.props.logout(); location.reload()}}>Logout</div>
        <div className="About">About</div>
        <div className="ArupLogo"></div>
      </div>
    );
  }
}

export default MenuBar;




// WEBPACK FOOTER //
// ./src/MenuBar.js